import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import TextInput from '../TextInput';
import IconButton from '../IconButton';
var ToggleButton = styled(IconButton).withConfig({
  displayName: "PasswordInput__ToggleButton",
  componentId: "sc-1x2rvc9-0"
})(["\n  min-width: 0;\n  min-height: 0;\n\n  &:focus {\n    outline: 0;\n    > svg {\n      color: ", ";\n    }\n  }\n"], function (props) {
  return props.theme.focusColor || '#7c89d3';
});

var PasswordInput =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(PasswordInput, _React$Component);

  function PasswordInput() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "state", {
      inputType: 'password'
    });

    _defineProperty(_assertThisInitialized(_this), "handleToggleVisibility", function () {
      _this.setState(function (state) {
        return {
          inputType: state.inputType === 'password' ? 'text' : 'password'
        };
      });
    });

    return _this;
  }

  var _proto = PasswordInput.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        allowToggleVisibility = _this$props.allowToggleVisibility,
        toggleButtonLabel = _this$props.toggleButtonLabel,
        props = _objectWithoutPropertiesLoose(_this$props, ["allowToggleVisibility", "toggleButtonLabel"]);

    var inputType = this.state.inputType;

    if (allowToggleVisibility) {
      var iconType = inputType === 'password' ? 'eyeCrossedOut' : 'eye';
      var icon = React.createElement(ToggleButton, {
        onClick: this.handleToggleVisibility,
        icon: {
          type: iconType
        },
        "aria-label": toggleButtonLabel
      });
      return React.createElement(TextInput, _extends({}, props, {
        type: inputType,
        icon: icon
      }));
    }

    return React.createElement(TextInput, _extends({}, props, {
      type: "password"
    }));
  };

  return PasswordInput;
}(React.Component);

_defineProperty(PasswordInput, "propTypes", {
  allowToggleVisibility: PropTypes.bool,
  toggleButtonLabel: PropTypes.string
});

_defineProperty(PasswordInput, "defaultProps", {
  allowToggleVisibility: true,
  toggleButtonLabel: 'Toggle password visibility'
});

export { PasswordInput as default };